const chevron = `<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L6 6L11 0.999999"/></svg>`;

try {
  window.$ = window.jQuery = require('jquery');
  require('select2');
} catch (e) {}

export const dropdowns = () => {
  $('.select-blog').select2({
    //dropdownParent: $(this).closest('.select-wrap'),
  });

  $('.select-careers').select2({
    //dropdownParent: $(this).closest('.select-wrap'),
  });

  $('.select-filter').select2({
    //dropdownParent: $(this).closest('.select-wrap'),
  });

  // add arrows to selects
  $('.select2-selection').append(`${chevron}`);
};
